export const componentSizes = [
  '',
  'default',
  'xxsmall',
  'xsmall',
  'small',
  'large',
  'xlarge',
] as const

export type ComponentSize = typeof componentSizes[number]

export const componentSizeMap = {
  large: 44,
  default: 36,
  small: 32,
} as const
